var Marionette = require('marionette'),
    SearchView = require('../../../searchView/view'); // may want to wrap in different parent forms ...


require('jqDropDown'); // now just using the plugin to show the content of the form view


module.exports = Marionette.ItemView.extend({

    initialize: function( options ) {

        this.channel = options.channel;
        this.detailsView = null; // could maybe render the markup as a region that is toggled ?

    },

    template: require('./template.hbs'),

    attributes: function() {

        var model = this.model;

        return  {
            class: 'fr-searchPillView' + ( model.get('isSelected') ? ' fr-searchPill-selected' : '' ),
            title: model.get('searchTerm')
        };

    },

    ui: {
        removeBtn:  '.fr-search-pill-remove',
        moreBtn:    '.fr-search-pill-more',
        editBtn:    '.fr-search-pill-edit'
    },

    events: {
        'click':                'toggleCollapsed',
        'click @ui.removeBtn':  'removeClicked',
        'click @ui.moreBtn':    'toggleSearchDialog',
        'click @ui.editBtn':    'editSearchClicked'
    },

    serializeData: function() {

        var hitsOfSearch = this.channel.request('state').get('searchResults').getHits().getHitsForSearch( this.model.cid );

        return {
            searchName: this.model.get('searchTerm'), // TODO: use identifier for display name where-ever needed ...
            numberOfHits: hitsOfSearch.length
        };

    },


    /* HACK -- copied from hit row -- see comments there */
    /* prob better to create on fly and append to zone below -- not hover */
    toggleSearchDialog: function(e) {

        /*
        this.detailsView = new SearchView({
            channel: this.channel,
            model: this.model // I want the search view actually ...
        });


        $('.FV').append( this.detailsView.render().el );

        this.detailsView.triggerMethod('beforeShow');

        this.ui.moreBtn.dropDown({
            content: this.detailsView.$el,
            isNotMenu: true
        });
        */


        e.stopPropagation();  // Don't allow to reach the 'click' event

        if ( !this.detailsView ) {

            var vChannel = this.channel.request('vChannel'); // area for perf gain ...

            this.detailsView = new SearchView({
                model: this.model,
                channel: this.channel,
                dontShowFormButtons: true,
                disableInputs: true,
                extraFormClassName: 'fr-search-details-popup'
            });


            // Note: would like to position relatively inside a container and not move on scroll,
            // but then dropdown would be positioned 'inside' the side container.
            // Area for optimization -wr::
            vChannel.request('getWrapper').append( this.detailsView.render().el);

            // Mimic a show event for it to render as we're calling calling from a region in the view
            this.detailsView.triggerMethod('beforeShow');

            // Note: custom open event wasn't working -- just use a click, which is working
            this.ui.moreBtn.dropDown({
                content: this.detailsView.$el,
                isNotMenu: true // don't capture click events on the dropdown (here view) -- also requires to prevent default click on inner view
            }).trigger('click');

        }

    },

    removeClicked: function( e ) {

        e.stopPropagation(); // Don't allow to reach the 'click' event which will call toggle collapsed and prevent issues
        this.channel.trigger( 'findAndRedact:removeSearch', this.model );

    },

    editSearchClicked: function( e ) {

        e.stopPropagation(); // Don't allow to reach the 'click' event
        this.channel.trigger( 'findAndRedact:showEditSearchModal', this.model );

    },

    toggleCollapsed: function( e ) {

        this.channel.trigger( 'findAndRedact:toggleCollapseSearch', this.model );
    },

    onBeforeDestroy: function() {

        this.detailsView && this.detailsView.destroy();
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/searchesView/searchPills/searchPillView.js
 ** module id = 641
 ** module chunks = 0
 **/